<template>
    <modal name="document-modal" :adaptive="true" :height="'auto'" @before-open="onModalShow">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <h4>Carica nuovo documento</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col text-center">
                                <div class="uploader-wrapper mb-3">
                                    <input type="file" ref="file" name="file" @change="handleFileUpload()" required/>
                                    <font-awesome-icon icon="cloud-upload-alt"></font-awesome-icon>
                                </div>
                                <div class="input-group mb-3" v-if="file">
                                    <input type="text" readonly class="form-control" :value="file.name" placeholder="" aria-label="" aria-describedby="">
                                    <div class="input-group-append">
                                        <button class="btn btn-danger" type="button" @click="resetFile">
                                            <font-awesome-icon icon="times"></font-awesome-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">
                                <div class="form-group mb-0">
                                    <label>Titolo documento *</label>
                                    <input v-on:keyup.13="submitFile" type="text" name="documentTitle" v-model="documentTitle" class="form-control" required/>
                                </div>
                            </div>
                        </div>
                        <!-- Server Errors -->
                        <div v-if="errors" class="alert alert-danger mb-0">
                            <span class="d-block" v-for="(error, i) in errors" :key="i">
                                <b>{{ i }}</b> <span v-for="(e, ie) in error" :key="ie">{{ e }}<br/></span>
                            </span>
                        </div>
                        <!-- Client Errors -->
                        <div v-if="$v.$error" class="alert alert-danger mb-0">
                            <span v-if="!$v.documentTitle.required">Il campo <i>Titolo documento</i> è richiesto.<br></span>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button type="submit" class="btn btn-success" @click="submitFile">
                            <font-awesome-icon icon="arrow-up" size="xs"></font-awesome-icon>&nbsp;Carica documento
                        </button>
                        <button type="button" class="btn btn-warning" @click="closeModal">
                            <font-awesome-icon icon="times"></font-awesome-icon>&nbsp;Annulla
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import {
    mapState,
    mapGetters
} from 'vuex'
import {
    AttachmentService
} from '@/common/api.service.js'
import {
    required
} from 'vuelidate/lib/validators'
import {
    GET_LIST
} from '@/store/actions.type'
import {
    MODULE_NAME
} from '@/store/modules/attachments.module'

export default {
    name: 'document-modal',
    data () {
        return {
            file: false,
            documentTitle: ''
        }
    },
    validations: {
        documentTitle: {
            required
        },
        file: {
            required
        }
    },
    computed: {
        ...mapState({
            errors: state => state.USERS.errors
        }),
        ...mapGetters([
            'currentUser'
        ])
    },
    methods: {
        submitFile () {
            this.$v.$touch()
            if (!this.$v.$invalid) {
                let formData = new FormData()
                formData.append('file', this.file)
                formData.append('title', this.documentTitle)
                AttachmentService.create(formData)
                    .then((
                        result
                    ) => {
                        if (result.status === 200) {
                            this.resetFile()
                            this.closeModal()
                            this.$store.dispatch(`${MODULE_NAME}/${GET_LIST}`, {
                                query: {}
                            })
                        }
                    }).catch(e => {
                        console.log(e)
                    })
            }
        },
        handleFileUpload () {
            this.file = this.$refs.file.files[0]
        },
        resetFile () {
            this.file = false
            this.documentTitle = ''
            this.$v.$reset()
        },
        closeModal () {
            this.$modal.hide('document-modal')
        },
        onModalShow () {
            this.$v.$reset()
        }
    }
}
</script>
<style lang="scss" scoped>
.uploader-wrapper {
    border: 2px dashed #ccc;
    position: relative;
    font-size: 20px;
    color: #f0f0f0;
    height: 50px;
    input {
        left: 0;
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 50px;
        z-index: 1;
        cursor: pointer;
    }
    &:hover {

    }
    svg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
</style>
